import { UTM } from '@ads/front-core/api'

export const formatUTM = (utm: UTM): UTM => ({
  source: utm?.source || undefined,
  campaign: utm?.campaign || undefined,
  medium: utm?.medium || undefined,
  term: utm?.term || undefined,
})
